import React from "react";
import { Outlet } from "react-router-dom";

const Root = props => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;

    return (
        <React.Fragment>
            <Outlet />
        </React.Fragment>
    );
};

export default Root;
